// extracted by mini-css-extract-plugin
export default {"table":"AdminPage_table_LDc7W","footer":"AdminPage_footer_CNtYZ"};